import React from 'react';
import { DAISY_SEAL_TOOLTIP } from '../lib/daisySeal';

interface AuthorizedAvatarFrameProps {
  children: React.ReactNode;
  sealed?: boolean;
  className?: string;
}

/**
 * Blue luminous border around the full modal card for DAISY-authorized members.
 * Corner seal/badge lives on the image block (see DaisySealBadge in ledger modal).
 */
export const AuthorizedAvatarFrame: React.FC<AuthorizedAvatarFrameProps> = ({
  children,
  sealed = false,
  className = '',
}) => {
  if (!sealed) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div className={`relative ${className}`} title={DAISY_SEAL_TOOLTIP}>
      <div
        className="absolute inset-0 rounded-xl pointer-events-none z-[5]"
        style={{
          boxShadow:
            'inset 0 0 0 3px rgba(14, 165, 233, 0.85), 0 0 18px rgba(56, 189, 248, 0.35)',
        }}
        aria-hidden
      />
      {children}
    </div>
  );
};

export default AuthorizedAvatarFrame;
